import { createGlobalState, useStorage } from '@vueuse/core';

export const useMessageHubDrafts = createGlobalState(() => {
    const drafts = useStorage('voxie-message-drafts', {}, sessionStorage);

    const generateDraftKey = (teamId, groupId, contactId) => {
        const parts = [teamId];
        if (groupId) {
            parts.push(groupId);
        }
        parts.push(contactId);
        return parts.join('_');
    };

    const getDraft = (teamId, groupId, contactId) => {
        const key = generateDraftKey(teamId, groupId, contactId);
        return drafts.value[key];
    };

    const saveDraft = (teamId, groupId, contactId, draftData) => {
        const key = generateDraftKey(teamId, groupId, contactId);

        const draft = {
            body: draftData.body || '',
            media_url: draftData.media_url || null,
            media_content_type: draftData.media_content_type || null,
        };

        if (draft.body?.trim() || draft.media_url) {
            drafts.value[key] = draft;
        } else {
            delete drafts.value[key];
        }
    };

    const clearDraft = (teamId, groupId, contactId) => {
        const key = generateDraftKey(teamId, groupId, contactId);
        delete drafts.value[key];
    };

    return {
        getDraft,
        saveDraft,
        clearDraft,
    };
});
